import { computeMilestoneStates } from '@/domains/jobs/constants/milestones';
import { useJobMilestoneHistory } from '@/domains/jobs/hooks/useJobMilestoneHistory';
import { CheckCircle2 } from 'lucide-react';

export function MilestonesCard({ jobId }: { jobId: number }) {
  const { data } = useJobMilestoneHistory(jobId);

  const milestones = computeMilestoneStates(data?.events ?? []);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-green-50 dark:bg-green-950 flex items-center justify-center">
          <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Milestones</h3>
          <p className="text-xs text-muted-foreground">Job progress tracking</p>
        </div>
      </div>

      <div className="space-y-2">
        {milestones.map(({ def, completed }, idx) => (
          <div key={def.matchKey} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              {completed ? (
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
              ) : (
                <div className="w-5 h-5 rounded-full border-2 border-slate-300 dark:border-slate-600 flex-shrink-0" />
              )}
              {idx < milestones.length - 1 && (
                <div
                  className={`w-0.5 h-4 mt-1 ${completed ? 'bg-green-300 dark:bg-green-700' : 'bg-slate-200 dark:bg-slate-700'}`}
                />
              )}
            </div>
            <span
              className={`text-sm font-medium mt-0.5 ${completed ? 'text-foreground' : 'text-muted-foreground'}`}
            >
              {def.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
